module.exports = __webpack_public_path__ + "static/media/closeIcon.3c20ac43.svg";